import { HeadProductDto, PublishStatus } from '@api/api-service';

export interface HeadProductDetailsStore extends HeadProductDto {
  error: string | null;
  selectedDimension: string | null;
  selectedOption1: string | null;
  selectedOption2: string | null;
  selectedOption3: string | null;
}

export const initialHeadProductDetailsStore: HeadProductDetailsStore = {
  error: null,
  id: 0,
  status: PublishStatus.Draft,
  products: [],
  selectedDimension: null,
  selectedOption1: null,
  selectedOption2: null,
  selectedOption3: null,
  minProductPrice: 0,
  maxProductPrice: 0
};
